/* PWL v17: single country/currency + language selector.
   PWL v18: option lists are cloned from <template id="PwlLocaleLists"> (rendered once per page).
   Native Shopify localization form (country_code + language_code); JS only opens/closes/filters.
   Inputs carry form="<id>", so on small screens the panel can be moved to <body> (escapes transformed ancestors). */
if (!customElements.get('pwl-locale')) {
  customElements.define('pwl-locale', class PwlLocale extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.trigger = this.querySelector('[data-pwl-locale-trigger]');
      this.panel = this.querySelector('[data-pwl-locale-panel]');
      if (!this.trigger || !this.panel) return;
      this.ready = true;
      this.fillLists();
      this.home = this.panel.parentNode;
      this.mq = window.matchMedia('(max-width: 989px)');
      this.trigger.addEventListener('click', (e) => { e.preventDefault(); this.isOpen() ? this.close() : this.open(); });
      this.panel.querySelectorAll('[data-pwl-locale-close]').forEach((b) => b.addEventListener('click', () => this.close(true)));
      const onKey = (e) => { if (e.key === 'Escape' && this.isOpen()) { e.stopPropagation(); this.escClosed = true; this.close(true); } };
      // Dawn's header drawer closes on Escape keyup; keep it open when Escape only closed this panel
      const onKeyUp = (e) => { if (e.key === 'Escape' && this.escClosed) { e.stopPropagation(); this.escClosed = false; } };
      [this.panel, this.trigger].forEach((el) => { el.addEventListener('keydown', onKey); el.addEventListener('keyup', onKeyUp); });
      this.onDoc = (e) => { if (this.isOpen() && !this.contains(e.target) && !this.panel.contains(e.target)) this.close(); };
      const filter = this.panel.querySelector('[data-pwl-locale-filter]');
      if (filter) {
        filter.addEventListener('input', () => this.filter(filter.value));
        filter.addEventListener('keydown', (e) => { if (e.key === 'Enter') e.preventDefault(); });
      }
      const form = this.querySelector('form');
      if (form) form.addEventListener('submit', () => { const b = this.panel.querySelector('.pwl-locale__apply'); if (b) b.setAttribute('aria-busy', 'true'); });
    }
    // PWL v18: lists are rendered once in <template id="PwlLocaleLists">; clone them into this instance.
    fillLists() {
      const tpl = document.getElementById('PwlLocaleLists');
      const form = this.querySelector('form');
      if (!tpl || !tpl.content) return;
      this.panel.querySelectorAll('[data-pwl-locale-slot]').forEach((slot) => {
        if (slot.children.length) return;
        const src = tpl.content.querySelector('[data-pwl-list="' + slot.dataset.pwlLocaleSlot + '"]');
        if (!src) return;
        const frag = document.createDocumentFragment();
        Array.prototype.forEach.call(src.children, (li) => frag.appendChild(li.cloneNode(true)));
        if (form && form.id) frag.querySelectorAll('input').forEach((i) => i.setAttribute('form', form.id));
        slot.appendChild(frag);
      });
    }
    isOpen() { return !!this.panel && !this.panel.hasAttribute('hidden'); }
    open() {
      document.querySelectorAll('pwl-locale').forEach((el) => { if (el !== this && el.isOpen && el.isOpen()) el.close(); });
      const sheet = this.mq.matches;
      if (sheet && this.dataset.context !== 'drawer' && this.panel.parentNode !== document.body) document.body.appendChild(this.panel);
      this.panel.removeAttribute('hidden');
      this.trigger.setAttribute('aria-expanded', 'true');
      if (sheet) { document.body.classList.add('pwl-locale-lock'); this.panel.setAttribute('aria-modal', 'true'); }
      document.addEventListener('click', this.onDoc, true);
      const checked = this.panel.querySelector('.pwl-locale__radio:checked');
      if (checked) {
        const li = checked.closest('.pwl-locale__item'); const list = checked.closest('.pwl-locale__list');
        if (li && list && !sheet) list.scrollTop = Math.max(0, li.offsetTop - list.offsetTop - 40);
        try { checked.focus({ preventScroll: true }); } catch (e) { checked.focus(); }
      }
    }
    close(returnFocus) {
      this.panel.setAttribute('hidden', '');
      this.panel.setAttribute('aria-modal', 'false');
      this.trigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('pwl-locale-lock');
      document.removeEventListener('click', this.onDoc, true);
      if (this.panel.parentNode !== this.home) this.home.appendChild(this.panel);
      if (returnFocus) this.trigger.focus();
    }
    filter(q) {
      q = (q || '').trim().toLowerCase();
      let shown = 0;
      this.panel.querySelectorAll('.pwl-locale__col--country .pwl-locale__item').forEach((li) => {
        const hit = !q || (li.dataset.name || '').indexOf(q) !== -1;
        li.hidden = !hit; if (hit) shown++;
      });
      const empty = this.panel.querySelector('[data-pwl-locale-empty]'); if (empty) empty.hidden = shown > 0;
    }
  });
}
